class EmbeddedConcentElement extends HTMLElement {
  elementIsInitialized = false
  constructor() {
    self = super();
    // Always call super first in constructor
    // Return value from super() is a reference to this element


    //this element need concent to be init
    this.addEventListener('initElement', (e) => {
      if (! this.elementIsInitialized) {
        this.initElement()
        this.elementIsInitialized = true;
      }
    }, false)

  }

  initElement(){
    //add code from constructor
  }

}

export default EmbeddedConcentElement
